import React, { useState } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { Breadcrumbs } from "../../../../Components";
import { Sidebar } from "./Cards/Sidebar";
import {
    Microsoft365Tab,
    // Individual components
    EntityTab,
    StatusTab,
    HolidayTab,
    EventTab,
    VenueTab,
    SettingsTab,
} from "../index";

// Reusable component for empty state
const EmptyState = ({ category }) => (
    <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
            Select a Setting
        </Typography>
        <Typography variant="body2" color="text.secondary">
            Choose a specific {category} setting from the sidebar to configure
        </Typography>
    </Box>
);

export const Settings = () => {

    const [selectedTab, setSelectedTab] = useState('general');

    const handleTabChange = (tabId) => {
        setSelectedTab(tabId);
    };

    const renderContent = () => {
        // Direct component mapping - much simpler!
        switch (selectedTab) {
            // Main tabs (show sub-menu selection)
            case 'general':
                return <EmptyState category="general" />;
            case 'security':
                return <EmptyState category="security" />;
            case 'notification':
                return <EmptyState category="notification" />;
            case 'roster':
                return <EmptyState category="roster" />;
            case 'integration':
                return <EmptyState category="integration" />;
            
            // Settings sub-tabs (unified)
            case 'general-settings':
                return <SettingsTab category="general-settings" />;
            case 'storage':
                return <SettingsTab category="storage" />;
            case 'login-settings':
                return <SettingsTab category="login-settings" />;
            case 'two-factor-auth':
                return <SettingsTab category="two-factor-auth" />;
            case 'sso-settings':
                return <SettingsTab category="sso-settings" />;
            case 'password-policy':
                return <SettingsTab category="password-policy" />;
            case 'ip-whitelist':
                return <SettingsTab category="ip-whitelist" />;
            case 'activity-log':
                return <SettingsTab category="activity-log" />;
            case 'token':
                return <SettingsTab category="token" />;
            case 'notification-settings':
                return <SettingsTab category="notification-settings" />;
            case 'roster-settings':
                return <SettingsTab category="roster-settings" actionMinWidth={220} controlSize="medium" />;
            case 'microsoft-settings':
                return <Microsoft365Tab />;
            
            // Data tabs (keep as they are)
            case 'data-status':
                return <StatusTab />;
            case 'data-entities':
                return <EntityTab />;
            case 'data-holidays':
                return <HolidayTab />;
            case 'data-events':
                return <EventTab />;
            case 'data-venues':
                return <VenueTab />;
            
            default:
                return <EmptyState category="setting" />;
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','SETTINGS']} sx={{display:'inline-block'}} />
                </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={3}>
                <Sidebar selectedTab={selectedTab} onTabChange={handleTabChange} />
            </Grid>
            <Grid item xs={12} sm={8} md={9} lg={9}>
                {renderContent()}
            </Grid>
        </Grid>
    );
};
